import locales from '../i18n/config';

export const getLocalizedPropertyByPrefix = (item, propertyName, locale) => {
    const localizedString = item[`${locale}${propertyName}`];
    return localizedString || item[decapitalize(propertyName)];
}


const decapitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toLowerCase() + s.slice(1)
}

export const delocalizePath = (path, locale) => {
    if(!locale || !path) return path;
    return path.split(`/${locales[locale].path}`).pop() || '/';
}

export const localizePath  = (path, locale) => {
    const isIndex = path === `/`;
    const localizedPath = locales[locale].default
        ? path
        : `/${locales[locale].path}${isIndex ? `` : `${path}`}`;
    return localizedPath;
}

export const languageSelectorLocalization = (fallbackPath, localizations) => {
    const locales = localizations.edges.reduce((memory, next) => {
        memory.push(next.node.language);
        return memory;
    }, []);
    return {fallback: fallbackPath, localesList: locales};
}

export const getDefaultLocale = () => {
    for(const key in locales) {
        if( locales[key] && locales[key].default) {
            return locales[key];
        }
    }
}


